import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface SubmitRunApprovalProps {
  runId: string;
  approvalGranted: boolean;
}

export const useSubmitRunApproval = (caseId?: string, matterId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const submitRunApproval = async (data: SubmitRunApprovalProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { approvalGranted: data.approvalGranted },
    });

    const response = await fetch(`${APIBaseChronos}/api/run/${data.runId}/approval`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to submit run approval');
    }
  };

  return useMutation({
    mutationFn: submitRunApproval,
    onSuccess: (_, variables) => {
      const message = variables.approvalGranted ? 'Processing approved and continuing' : 'Processing cancelled';
      toast.success(message);
    },
    onError: () => {
      toast.error('Failed to submit approval decision');
    },
    onSettled: () => {
      if (!caseId || !matterId) return;
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Case, caseId] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocSubsets, { matterId }] });
    },
  });
};
